import React, { useEffect, useState } from "react";
import axios from "../Requests/axios";
import request from "../Requests/request";
import "../Styles/banner.css";

const Banner = () => {
  const [movie, setMovies] = useState([]);
  useEffect(() => {
    // (async () => {
    //   const processRequest = await axios.get(request.fetchNetflixOriginals);
    //   setMovies(
    //     processRequest.data.results[
    //       Math.floor(Math.random() * processRequest.data.results.length)
    //     ]
    //   );
    // })();
    axios.get(request.fetchNetflixOriginals).then((processRequest) => {
      setMovies(
        processRequest.data.results[
          Math.floor(Math.random() * processRequest.data.results.length)
        ]
      );
    });
  }, []);

  let truncate = (str, n) =>
    str?.length > n ? str.substr(0, n - 1) + "..." : str;

  // console.log(movie);
  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
        backgroundPosition: "center center",
      }}
    >
      <div className="banner__contents">
        <h1 className="banner__title">
          {movie?.title || movie?.name || movie?.original_name}
        </h1>
        <div className="banner__buttons">
          <button className="banner__button">Play</button>
          <button className="banner__button">My List</button>
        </div>

        <h1 className="banner__description">
          {truncate(movie?.overview, 150)}
        </h1>
      </div>

      <div className="banner--fadeBottom"></div>
    </header>
  );
};

export default Banner;
